import { PosStatusPage } from './../pos-status/pos-status';
import { PosSalePage } from './../pos-sale/pos-sale';
import { PosTransactionPage } from './../pos-transaction/pos-transaction';
import { PosTablePage } from './../pos-table/pos-table';
import { PosDsPage } from './../pos-ds/pos-ds';
import { FoDeparturePage } from './../fo-departure/fo-departure';
import { FoArrivalPage } from './../fo-arrival/fo-arrival';
import { FoInhousePage } from './../fo-inhouse/fo-inhouse';
import { FoInfoPage } from './../fo-info/fo-info';
import { FoInventoryPage } from './../fo-inventory/fo-inventory';
import { FoStatisticPage } from './../fo-statistic/fo-statistic';
import { CheckoutPage } from './../checkout/checkout';
import { AuthProvider } from './../../providers/auth/auth';
import { Component } from '@angular/core';
import { NavController, AlertController, LoadingController, NavParams, Loading } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { LoginPage } from '../login/login';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  hotelname = '';
  username = '';
  isposthotel = 1;
  showInventory = false;
  mode: string = 'fo';

  tabStatistic = FoStatisticPage;
  tabInfo = FoInfoPage;
  tabInhouse = FoInhousePage;
  tabArrival = FoArrivalPage;
  tabDeparture = FoDeparturePage;
  tabInventory = FoInventoryPage;
  tabCheckout = CheckoutPage;

  tabPOSDs = PosDsPage;
  tabPOSTable = PosTablePage;
  tabPOSTransaction = PosTransactionPage;
  tabPOSSale = PosSalePage;
  tabPOSStatus = PosStatusPage;

  constructor(public navCtrl: NavController, private auth: AuthProvider, public navParams: NavParams,
    private alertCtrl: AlertController, private loadingCtrl: LoadingController, private global: GlobalProvider) {

    var onParam = this.navParams.get('icno');
    this.isposthotel = parseInt(this.navParams.get('isposthotel'), 10);
    this.auth.currentUser.icno = onParam;
    this.global.ICNO = onParam;
    this.global.HotelName = this.navParams.get('hotelname');
    this.hotelname = this.global.HotelName;

    let info = this.auth.getUserInfo();
    this.username = info.username;
    this.showInventory = (this.username.toUpperCase() === 'AIPENG');

    if (this.isposthotel === 0) {
      this.mode = 'pos';
    } else {
      this.mode = 'fo';
    }
  }

  switchMode(newMode: string) {
    if (this.mode !== newMode) {
      this.mode = newMode;
    }
  }

  isTitleLong(): boolean {
    const name = this.hotelname ? this.hotelname : 'iDashboard';
    return name.length > 30;
  }

  logmeout() {
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad HomePage');
  }
}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts